import userApis from "apis/users";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const LeadsPage = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const jwt = useSelector((state) => state?.auth?.jwt);

  useEffect(() => {
    const api = new userApis(jwt);
    // Fetch leads from the API
    const fetchLeads = async () => {
      try {
        setLoading(true);
        const response = await api.getLeads(); // Assuming `getLeads` fetches the leads
        setLeads(response); // Set the leads data
      } catch (err) {
        setError("Failed to fetch leads.");
      } finally {
        setLoading(false);
      }
    };

    fetchLeads();
  }, []);

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Leads</h1>
      {loading && <p className="text-xl text-gray-500">Loading leads...</p>}
      {error && <p className="text-xl text-red-500">{error}</p>}
      <div className="overflow-x-auto">
        <table className="min-w-full table-auto border-collapse">
          <thead>
            <tr className="bg-indigo-600 text-white">
              <th className="py-2 px-4 border">Name</th>
              <th className="py-2 px-4 border">Email</th>
              <th className="py-2 px-4 border">Phone Number</th>
              <th className="py-2 px-4 border">Message</th>
            </tr>
          </thead>
          <tbody>
            {leads.map((lead) => (
              <tr key={lead.id} className="hover:bg-gray-100">
                <td className="py-2 px-4 border">{lead.name}</td>
                <td className="py-2 px-4 border">{lead.email}</td>
                <td className="py-2 px-4 border">{lead.phoneNumber}</td>
                <td className="py-2 px-4 border">{lead.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LeadsPage;
